export default function computeTransferStatus(transferMethod) {
  switch (transferMethod) {
    case 'Wire':
      return 'awaiting wire';
    case 'ACH':
      return 'pending';
    default:
      return 'pending';
  }
}
